import { useEffect, useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { refreshAccessToken } from '../../../../utilities/extensions'
import { apiURL } from '../../../../utilities/URLs'
import { account } from '../../../../classes/Account'

export default function ESign3911() {
  const navigate = useNavigate()
  const { applicationId } = useParams()
  const [searchParams] = useSearchParams()
  const quarter = searchParams.get('quarter') ?? ''

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [signingUrl, setSigningUrl] = useState('')

  useEffect(() => { createSession() }, [])

  // Listen for ESIGN_COMPLETE from the iframe
  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data?.type === 'esign_complete' || event.data?.type === 'ESIGN_COMPLETE') {
        // POST to backend to update quarter status
        const completeResponse = await fetch(`${apiURL}/api/applications/${applicationId}/e-sign/3911/?quarter=${quarter}`, {
          method: 'POST',
          headers: {
            'Authorization': account.accessToken,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ quarter })
        })
        if (completeResponse.ok)
          navigate(`/applications/${applicationId}/dashboard`)
      }
    }
    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [applicationId, quarter])

  const createSession = async () => {
    setLoading(true)
    setError('')

    try {
      const response = await fetch(`${apiURL}/api/applications/${applicationId}/e-sign/3911?quarter=${quarter}`, {
        headers: { 'Authorization': account.accessToken }
      })
      const data = await response.json()

      if (data.response?.error) {
        if (data.response.error === 'Failed To Authenticate Token.') {
          const refreshed = await refreshAccessToken()
          if (refreshed) return createSession()
          navigate('/', { state: { expired: true } })
          return
        }
        setError(data.response.error)
        return
      }

      if (data.response.already_signed) {
        setError('Unable to start a new signing session. Please refresh the page or contact support.')
        return
      }

      setSigningUrl(data.response.signing_url)
    } catch (err) {
      setError('Failed to prepare Form 3911. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className='flex flex-row items-center justify-center gap-2 py-8 transition-colors duration-300'>
        <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
        <p className='text-slate-600 dark:text-slate-300'>Loading document...</p>
      </div>
    )
  }

  if (error) {
    return (
      <div className='flex flex-col items-center justify-center gap-4 p-8 transition-colors duration-300'>
        <div className='bg-red-50 dark:bg-red-900/10 border border-red-200 dark:border-red-500/20 rounded-lg p-6 max-w-md text-center'>
          <p className='text-red-600 dark:text-red-400 font-medium mb-4'>{error}</p>
          <button
            onClick={() => { setError(''); createSession() }}
            className='px-6 py-2 bg-ertc-primary text-white rounded-lg hover:bg-ertc-primary-dark transition-all'
          >
            Try Again
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className='w-full flex-1 min-h-0'>
      <iframe
        src={signingUrl}
        className='w-full h-full border-0 rounded-lg'
        title='E-Sign Form 3911'
        allow='fullscreen'
      />
    </div>
  )
}